var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSlotsAllocated(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2112 1H8.78613C5.79776 1 5.13768 2.48819 4.75363 4.31241L3.39746 10.8053H22.5999L21.2437 4.31241C20.8596 2.48819 20.1996 1 17.2112 1Z",
    stroke: "#FA7B42",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6826 14.0811C1.85062 12.2809 2.19866 10.8047 5.34305 10.8047H20.6569C23.8013 10.8047 24.1494 12.2809 24.3174 14.0811L24.9895 21.39C25.1215 22.7942 23.9934 24.0063 22.5532 24.0063H20.2969C19.0007 24.0063 18.8207 23.4543 18.5927 22.7702L18.3527 22.0501C18.0166 21.066 17.8006 20.4059 16.0724 20.4059H9.92762C8.19941 20.4059 7.94738 21.15 7.64734 22.0501L7.40731 22.7702C7.17928 23.4543 6.99926 24.0063 5.7031 24.0063H3.44682C2.00664 24.0063 0.878497 22.7942 1.01051 21.39L1.23854 18.9177",
    stroke: "#FA7B42",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.39742 7.2041H2.19727",
    stroke: "#FA7B42",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7998 7.2041H22.5996",
    stroke: "#FA7B42",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.999 1.2041V3.6044",
    stroke: "#FA7B42",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1992 3.60352H14.7997",
    stroke: "#FA7B42",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.79883 15.6064H9.39928",
    stroke: "#FA7B42",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5996 15.6064H20.2001",
    stroke: "#FA7B42",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlotsAllocated);
export default __webpack_public_path__ + "static/media/slots_allocated.a22aeb9d08e74be03d9fe0675b2b7b00.svg";
export { ForwardRef as ReactComponent };